.root {
  --icon-button--color--main: var(--theme--color--primary--main);
  --icon-button--color--contrast: var(--theme--color--primary--contrast);
  --icon-button--color--dark: var(--theme--color--primary--dark);
  --icon-button--color--ultra-light: var(--theme--color--primary--ultra-light);
  --icon-button--size: 32px;

  &.inheritColor {
    --icon-button--color--main: 'inherit';
  }

  &.sm {
    --icon-button--size: 20px;
  }

  &.md {
    --icon-button--size: 32px;
  }

  &.lg {
    --icon-button--size: 40px;
    font-size: var(--theme--typo--h3--size);
  }

  &.disabled {
    --icon-button--color--main: var(--theme--color--grey--main);
    --icon-button--color--contrast: var(--theme--color--grey--contrast);
    --icon-button--color--dark: var(--theme--color--grey--dark);
    --icon-button--color--ultra-light: var(--theme--color--grey--ultra-light);
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.4;

    &:focus-visible {
      outline: none;
    }
  }

  &.inline {
    aspect-ratio: unset;
    width: unset;
    color: var(--icon-button--color--main);
    border: none;
    background: transparent;
    padding: 0;

    &:hover,
    &:focus-visible {
      outline: var(--theme--token--focus--outline);
      outline-offset: var(--theme--token--focus--offset);

      color: var(--icon-button--color--dark);
      background: transparent;
    }
  }

  &.plain {
    color: var(--icon-button--color--main);
    border: none;
    background: transparent;

    &:hover,
    &:focus-visible {
      background: transparent;
    }
  }

  &.outlined {
    color: var(--icon-button--color--main);
    border: solid var(--theme--tokens--icon-button--border-width) var(--icon-button--color--main);
    background: transparent;

    &:hover,
    &:focus-visible {
      background: var(--icon-button--color--ultra-light);
    }
  }

  &.text {
    color: var(--icon-button--color--main);
    background: transparent;

    &:hover,
    &:focus-visible {
      color: var(--icon-button--color--dark);
      background: var(--icon-button--color--ultra-light);
    }
  }

  &.round {
    border-radius: 100%;
  }

  & {
    display: inline-flex;
    appearance: none;
    outline: none;
    border: none;
    border-radius: var(--theme--tokens--icon-button--border-radius);
    aspect-ratio: 1 / 1;
    width: var(--icon-button--size);
    flex-shrink: 0;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: var(--theme--typo--paragraph--size);
    transition: background var(--theme--transition--default),
    color var(--theme--transition--default);

    color: var(--icon-button--color--contrast);
    background: var(--icon-button--color--main);

    &:hover,
    &:focus-visible {
      background: var(--icon-button--color--dark);
    }

    &:focus-visible {
      outline: var(--theme--token--focus--outline);
      outline-offset: var(--theme--token--focus--offset);
    }
  }
}